module.exports = require("./lo.d.ts");